import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import FileUploadRepository from '../../loaders/fileUploadRepository'
import { useSelector, useDispatch } from 'react-redux'
import { toggleModal } from '../../../reducers/modalReducer'

const FileLoaderModal = ({ modalType }) => {
    const dispatch = useDispatch()
    const { percent = 20, fileName = null, totalFiles = null, filesUploaded = null } = useSelector((state) => state.modal)
    return (
        <>
            <ModalWrapper modalType={modalType} modalCardClasses="maw800px pr" >
                <img
                    style={{
                        position: "absolute",
                        right: "-1rem",
                        top: "-1rem"
                    }}
                    src={require("../../../../images/icon.png")}
                    alt='iconDiligentsia'
                />
                {/* Minimize button for auto-fill modals */}
                {(modalType === "computerToClarence" || modalType === "fileUploadFilingAssistant") && (
                    <div
                        onClick={() => dispatch(toggleModal({ open: '', autoFillStatusBarVisible: true }))}
                        style={{
                            position: 'absolute', top: '12px', right: '40px', zIndex: 2,
                            background: '#F3F4F6', borderRadius: '8px', width: '36px', height: '36px',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                        }}
                        title="Minimize to status bar"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19" stroke="#374151" strokeWidth="2.5" strokeLinecap="round" />
                        </svg>
                    </div>
                )}
                {
                    modalType === "computerToDataRepository" ?
                        <FileUploadRepository
                            percent={percent}
                            fileName={fileName}
                            filesUploaded={filesUploaded}
                            totalFiles={totalFiles}
                            gifFile={<img src={require("../../../../images/loaders/pc-to-data-repository.gif")} alt="fileUpload" />}
                            from="Your Computer"
                            to="Data Repository"
                        /> :
                        modalType === "fileUploadFilingAssistant" ?
                            <FileUploadRepository
                                percent={percent}
                                gifFile={<img src={require("../../../../images/loaders/clarence-to-data-repository.gif")} alt="fileUpload" />}
                                from="Clarence"
                                to="Data Repository"
                                heading="Allocating files to sections and questions"
                            /> :
                            modalType === "computerToClarence" ?
                                <FileUploadRepository
                                    percent={percent}
                                    fileName={fileName}
                                    filesUploaded={filesUploaded}
                                    totalFiles={totalFiles}
                                    gifFile={<img src={require("../../../../images/loaders/pc-to-data-clarence.gif")} alt="pc-to-data-clarence" />}
                                    from="Your Computer"
                                    to="Clarence"
                                />
                                : <></>
                }
            </ModalWrapper>
        </>
    )
}

export default FileLoaderModal